import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Fornitore } from '../models/models/pages/anagfornitori';

@Injectable({ providedIn: 'root' })
export class AnagFornitoriService {
  private baseUrl = `${environment.baseApiUrl}/anag-fornitori`; 

  constructor(private http: HttpClient) {}

  /** Lista semplice */
  list(params?: { page?: number; size?: number; sort?: string }): Observable<Fornitore[]> {
    let httpParams = new HttpParams();
    if (params?.page != null) httpParams = httpParams.set('page', params.page);
    if (params?.size != null) httpParams = httpParams.set('size', params.size);
    if (params?.sort) httpParams = httpParams.set('sort', params.sort);

    return this.http.get<Fornitore[]>(this.baseUrl, {
      params: httpParams,
      withCredentials: true,
    });
  }

  /** Lista con paginazione (usa header X-Total-Count) */
  listPage(params?: { page?: number; size?: number; sort?: string }): Observable<{ content: Fornitore[]; total: number }> {
    let httpParams = new HttpParams();
    if (params?.page != null) httpParams = httpParams.set('page', params.page);
    if (params?.size != null) httpParams = httpParams.set('size', params.size);
    if (params?.sort) httpParams = httpParams.set('sort', params.sort);

    return this.http.get<Fornitore[]>(this.baseUrl, {
      params: httpParams,
      withCredentials: true,
      observe: 'response',
    }).pipe(
      map(res => ({
        content: res.body ?? [],
        total: Number(res.headers.get('X-Total-Count') ?? (res.body?.length ?? 0)),
      }))
    );
  }

  get(id: number): Observable<Fornitore> {
    return this.http.get<Fornitore>(`${this.baseUrl}/${id}`, { withCredentials: true });
  }

  create(payload: Omit<Fornitore, 'id'>): Observable<Fornitore> {
    return this.http.post<Fornitore>(this.baseUrl, payload, { withCredentials: true });
  }

  /** PUT completo: id nel path deve coincidere con body.id */
  update(entity: Fornitore): Observable<Fornitore> {
    return this.http.put<Fornitore>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
  }

  /** PATCH parziale (merge-patch) */
  partialUpdate(id: number, patch: Partial<Fornitore>): Observable<Fornitore> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
    return this.http.patch<Fornitore>(`${this.baseUrl}/${id}`, patch, { headers, withCredentials: true });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
  }
}
